/* eslint-disable */
import { API, API_PROVINCE, standardResponse } from "./middleware";

/**
 *
 * @param {number} phoneNumber
 * @param {string} password
 * @returns {standardResponse}
 */
export async function loginWithPassword(phoneNumber, password) {
  const url = "/services/iamservice/api/login";
  const params = {
    tel: phoneNumber,
    password: password,
  };

  return API.post(url, params)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

/**
 *
 * @param {number} phoneNumber
 * @param {number} otp
 * @returns {standardResponse}
 */
export async function verifyOTPLogin(phoneNumber, otp) {
  const url = "/services/iamservice/api/otpLogin";
  const params = {
    tel: phoneNumber,
    otp: otp,
  };

  return API.post(url, params)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

/**
 *
 * @param {number} phoneNumber
 * @param {string} password
 * @param {string} rePassword
 * @returns {standardResponse}
 */
export async function changePasswordFirstTime(phoneNumber, oldPassword, password, rePassword) {
  const url = "/services/iamservice/api/changePasswordFirstTime";
  const params = {
    tel: phoneNumber,
    oldPassword: oldPassword,
    password: password,
    confirmPassword: rePassword,
  };

  return API.post(url, params)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

/**
 *
 * @param {number} phoneNumber
 * @returns {standardResponse}
 */
export async function getOTPForgotPassword(phoneNumber) {
  const url = "/services/iamservice/api/generate-otp?tel=" + phoneNumber;

  return API.get(url)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

/**
 *
 * @param {number} phoneNumber
 * @param {number} otp
 * @returns {standardResponse}
 */
export async function verifyOTPForgotPassword(phoneNumber, otp) {
  const url = "/services/iamservice/api/check-otp";
  const params = {
    tel: phoneNumber,
    otp: otp,
  };

  return API.post(url, params)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response);
    });
}

/**
 *
 * @param {number} phoneNumber
 * @param {string} password
 * @param {string} rePassword
 * @returns {standardResponse}
 */
export async function resetPassword(phoneNumber, password, rePassword) {
  const url = "/services/iamservice/api/forgot-password";
  const params = {
    tel: phoneNumber,
    password: password,
    confirmPassword: rePassword,
  };

  return API.post(url, params)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

export async function getListProvince() {
  const url = "/p";

  return API_PROVINCE.get(url)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

export async function getListDistrict(provinceId) {
  const url = "/p/" + provinceId + "?depth=2";

  return API_PROVINCE.get(url)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

export async function getListWard(districtId) {
  const url = "/d/" + districtId + "?depth=2";

  return API_PROVINCE.get(url)
    .then((response) => {
      return standardResponse(true, response);
    })
    .catch((error) => {
      return standardResponse(false, error.response?.data);
    });
}

export function generateOTP(phoneNumber) {
  const url = `services/iamservice/api/client-generate-otp?tel=${phoneNumber}`;
  return API.get(url)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}
